import {
  DataTable,
  DateTrunc,
  DateWindow,
  DateWindowTypes,
  MetricsDisabled,
  MetricsGrey,
} from '@tableau/metrics-engine';
import { RadioButtonWithLabelGroupWidget, RadioButtonWithLabelOption, RadioLayoutType } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../gen-src/Localize';
import { dateTruncToString } from '../../../utils';
import { customDateWindow } from '../configurationStyles';
import { DateWindowRelativeDateComponent } from './DateWindowRelativeDateComponent';
import { DateWindowStartDateComponent } from './DateWindowStartDateComponent';

const relativeWindowTestId = 'date-window-relative-units';
const startDateTestId = 'date-window-calendar-picker';

export interface DateWindowCustomComponentProps {
  testId: string;
  dateTrunc: DateTrunc;
  data: DataTable;
  selectedDateWindow: DateWindow | null;
  onChange: (value: DateWindow | null) => void;
  validationCounter?: number;
  disabled?: boolean;
}

const RELATIVE_WINDOW_INDEX = 0;
const CUSTOM_START_DATE_INDEX = 1;

export const DateWindowCustomComponent = (props: DateWindowCustomComponentProps) => {
  const [checkedIndex, setCheckedIndex] = React.useState<number>(indexForSelectedWindow(props.selectedDateWindow));

  const buttonList: RadioButtonWithLabelOption<string>[] = [
    {
      label: (
        <>
          {Messages.RelativeDate({ granularity: dateTruncToString(props.dateTrunc) })}
          <br />
          {checkedIndex === RELATIVE_WINDOW_INDEX && (
            <DateWindowRelativeDateComponent
              testId={relativeWindowTestId}
              dateTrunc={props.dateTrunc}
              onDateWindowChange={props.onChange}
              selectedDateWindow={props.selectedDateWindow}
              validationCounter={props.validationCounter}
              disabled={props.disabled}
            />
          )}
        </>
      ),
      testId: relativeWindowTestId,
      value: relativeWindowTestId,
      disabled: props.disabled,
    },
    {
      label: (
        <>
          {Messages.CustomStartDate()}
          {checkedIndex === CUSTOM_START_DATE_INDEX && (
            <DateWindowStartDateComponent
              testId={startDateTestId}
              dateTrunc={props.dateTrunc}
              data={props.data}
              onDateWindowChange={props.onChange}
              selectedDateWindow={props.selectedDateWindow}
              disabled={props.disabled}
            />
          )}
        </>
      ),
      testId: startDateTestId,
      value: startDateTestId,
      disabled: props.disabled,
    },
  ];

  const handleChange = (value: string, newCheckedIndex: number) => {
    setCheckedIndex(newCheckedIndex);
  };

  const color = props.disabled ? MetricsDisabled : MetricsGrey;

  return (
    <div data-tb-test-id="date-window-custom-wrapper">
      <RadioButtonWithLabelGroupWidget
        {...{
          className: customDateWindow,
          buttonList: buttonList,
          checkedIndex: checkedIndex,
          handleChange: handleChange,
          label: <b style={{ color }}>{Messages.CustomRange()}</b>,
          layout: RadioLayoutType.Veritical,
          testId: props.testId,
          removeLeftMargin: true,
          disabled: props.disabled,
        }}
      />
    </div>
  );
};

const indexForSelectedWindow = (window: DateWindow | null): number => {
  if (window?.type === DateWindowTypes.DEFINED_START) {
    return CUSTOM_START_DATE_INDEX;
  }
  return RELATIVE_WINDOW_INDEX;
};
